import { removeUnderScores } from "../../utils"
import { TimeBasedDocStatus, ValidEmploymentStatus } from "../../types"

export class DocValidityRecord {
  private idPassport = ""
  private competency = ""
  private status = "" as TimeBasedDocStatus
  private expiryDate = ""
  private name = ""
  private surname = ""
  private employmentStatus = "EMPLOYEE" as ValidEmploymentStatus
  private workSite = ""
  private filename = ""

  constructor(json: any) {
    if (json === undefined) {
      return
    }
    this.idPassport = json.idPassport || "-"
    this.competency = json.competency ? removeUnderScores(json.competency) : "NONE"
    this.status = json.status as TimeBasedDocStatus
    this.expiryDate = json.expiryDate || "-"
    this.name = json.name || "-"
    this.surname = json.surname || "-"
    this.employmentStatus = json.employmentStatus || "-"
    this.workSite = json.workSite ? removeUnderScores(json.workSite) : "-"
    this.filename = json.filename || ""
  }

  getIdPassport(): string {
    return this.idPassport
  }

  getStatus() {
    return this.status
  }

  getPreRequisiteName() {
    return this.competency
  }

  getExpiryDate() {
    return this.expiryDate
  }

  getMetaData() {
    return {
      idPassport: this.idPassport,
      competency: this.competency,
      status: this.status,
      expiryDate: this.expiryDate,
      name: this.name,
      surname: this.surname,
      employmentStatus: this.employmentStatus,
      workSite: this.workSite,
      filename: this.filename,
    }
  }
}
